import React from 'react';
import ErrorUtil from './ErrorUtil';
import { GLOBAL_APP_NAME } from './TranslationsProvider';
export const parseTextParams = (textValue, paramObject) => {
    return Object.keys(paramObject).reduce((text, key) => text.replace(`$\{${key}}`, paramObject[key]), textValue);
};
export const containsHtml = (value) => {
    const htmlTagRegexp = new RegExp('<\\/?((?!(iframe)\\b)\\w*)\\/?>');
    return htmlTagRegexp.test(value);
};
export const createEmptyTranslations = (app) => {
    const emptyTranslations = {};
    emptyTranslations[GLOBAL_APP_NAME] = {};
    emptyTranslations[app] = {};
    return emptyTranslations;
};
export const translateByApp = (translations, app, key, paramObject, ignoreErrors, jsxRenderer) => {
    const nullSafeTranslations = translations || createEmptyTranslations(app);
    const value = getTranslationForGroup(nullSafeTranslations, app, key, paramObject, !ignoreErrors);
    if (containsHtml(value)) {
        return translateHtml(value, jsxRenderer);
    }
    return value;
};
export const translateHtml = (value, JsxRenderer) => {
    if (JsxRenderer) {
        return React.createElement(JsxRenderer, { jsx: value });
    }
    return React.createElement("span", { dangerouslySetInnerHTML: { __html: value } });
};
export const getTranslationForGroup = (translations, group, key, paramObject, logMissingTranslation = true) => {
    const groupTranslations = translations[group];
    const label = `${group}:${key}`;
    let textValue;
    if (groupTranslations) {
        textValue = groupTranslations[key];
    }
    if (textValue) {
        if (paramObject) {
            return parseTextParams(textValue, paramObject);
        }
        return textValue;
    }
    if (logMissingTranslation && Object.keys(groupTranslations || {}).length) {
        const error = new Error('Translation missing');
        error.stack = `label: ${label} , page: ${window.location.pathname}`;
        ErrorUtil.pushErrorToPlumbrAndLog(error);
    }
    return label;
};
const resolveCommonApiBaseUrl = (tier) => {
    if (tier === 'local') {
        return 'https://www-dev.telia.ee/common/api';
    }
    else if (['dev', 'test'].includes(tier)) {
        return `https://www-${tier}.telia.ee/common/api`;
    }
    return 'https://www.telia.ee/common/api';
};
export const resolveStatisticsUrl = (tier) => {
    return `${resolveCommonApiBaseUrl(tier)}/translations/statistics`;
};
export const resolveGlobalTranslationsUrl = (tier, lang) => {
    return `${resolveCommonApiBaseUrl(tier)}/translations/${lang}?appNames=global`;
};
export const mergeTranslations = (prevTranslations, newTranslations) => {
    return { ...(prevTranslations || {}), ...newTranslations };
};
export const translateOrEmpty = (translations, app, key, paramObject, logMissingTranslation = false, jsxRenderer) => {
    const translation = getTranslationForGroup(translations || createEmptyTranslations(app), app, key, paramObject, logMissingTranslation);
    if (`${app}:${key}` === translation) {
        return '';
    }
    if (containsHtml(translation)) {
        return translateHtml(translation, jsxRenderer);
    }
    return translation;
};
